import script from "./RejectedJobListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RejectedJobListView.vue?vue&type=script&lang=ts&setup=true"

import "./RejectedJobListView.vue?vue&type=style&index=0&id=7e7a5b13&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7a5b13"]])

export default __exports__